document.addEventListener('DOMContentLoaded', () => {
  const initStickyPDPGallery = () => {
    const mediaWrapper = document.querySelector('.product--columns .product__media-wrapper');
    const variantPicker = document.querySelector('variant-radios') || document.querySelector('variant-selects');

    if (!mediaWrapper || !variantPicker) return;

    const BREAKPOINT = 990;
    const mediaGallery = mediaWrapper.querySelector('.product__media-gallery');

    const updateStickyBoundary = () => {
      if (window.innerWidth < BREAKPOINT) {
        mediaWrapper.style.height = '';
        return;
      }

      if (!mediaGallery) return;

      const wrapperTop = mediaWrapper.getBoundingClientRect().top;
      const pickerBottom = variantPicker.getBoundingClientRect().bottom;
      const galleryHeight = mediaGallery.getBoundingClientRect().height;
      const height = pickerBottom - wrapperTop + galleryHeight;

      if (height > 0) {
        mediaWrapper.style.height = `${height}px`;
      }
    };

    updateStickyBoundary();

    const infoWrapper = document.querySelector('.product__info-wrapper');
    const targets = [infoWrapper, variantPicker].filter(Boolean);

    const observer = new ResizeObserver(updateStickyBoundary);
    targets.forEach((el) => observer.observe(el));
  };

  initStickyPDPGallery();
});
